import React from 'react';
import PropTypes from 'prop-types';

/**
 * Loader component for loading states
 * @param {Object} props - Component props
 * @param {string} props.size - Size of the loader (sm, md, lg)
 * @param {string} props.color - Color of the loader
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element} Loader component
 */
const Loader = ({ size = 'md', color = 'blue', className = '' }) => {
  // Size mapping
  const sizeMap = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
  };
  
  // Color mapping
  const colorMap = {
    blue: 'border-blue-500',
    gray: 'border-gray-500',
    green: 'border-green-500',
    red: 'border-red-500',
    yellow: 'border-yellow-500',
    indigo: 'border-indigo-500',
    purple: 'border-purple-500',
    pink: 'border-pink-500',
  };
  
  return (
    <div className={`${className}`}>
      <div
        className={`animate-spin rounded-full border-t-transparent ${sizeMap[size]} border-4 ${colorMap[color]}`}
      ></div>
    </div>
  );
};

Loader.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  color: PropTypes.oneOf([
    'blue',
    'gray',
    'green',
    'red',
    'yellow',
    'indigo',
    'purple',
    'pink',
  ]),
  className: PropTypes.string,
};

export default Loader;